import Close from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { deviceSlice } from '../../common/store/deviceSlice';
import { AppState, appStore } from '../../common/store/store';

const InsightDrawer: React.FC = React.memo(() => {
    const [searchParams, setSearchParams] = useSearchParams();
    const insightRoute = useSelector((state: AppState) => state.device.insight);
    const [isResizing, setIsResizing] = React.useState(false);

    const getDefaultWidth = () => Math.min(window.innerWidth * 0.33, 800);
    const [drawerWidth, setDrawerWidth] = React.useState(() => {
        const saved = localStorage.getItem('insightDrawerWidth');
        return saved ? parseInt(saved) : getDefaultWidth();
    });

    React.useEffect(() => {
        const handleMouseMove = (e: MouseEvent) => {
            if (!isResizing) return;
            const newWidth = window.innerWidth - e.clientX;
            if (newWidth >= 200 && newWidth <= window.innerWidth * 0.8) {
                setDrawerWidth(newWidth);
                localStorage.setItem('insightDrawerWidth', newWidth.toString());
            }
        };

        const handleMouseUp = () => {
            setIsResizing(false);
        };

        if (isResizing) {
            document.addEventListener('mousemove', handleMouseMove);
            document.addEventListener('mouseup', handleMouseUp);
        }

        return () => {
            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isResizing]);

    const closeInsight = () => {
        const url = new URL(window.location.href);
        url.searchParams.delete('insight');
        window.history.pushState({}, '', url.toString());
        appStore.dispatch(deviceSlice.actions.setInsight(''));
    };

    if (!insightRoute) return null;

    return (
        <Drawer
            anchor="right"
            open={!!insightRoute}
            variant="persistent"
            sx={{
                width: drawerWidth,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: drawerWidth,
                    boxSizing: 'border-box',
                },
            }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    left: 0,
                    top: 0,
                    width: '4px',
                    height: '100%',
                    cursor: 'col-resize',
                    backgroundColor: 'transparent',
                    '&:hover': {
                        backgroundColor: 'primary.main',
                    },
                    zIndex: 1000,
                }}
                onMouseDown={(event) => {
                    event.preventDefault();
                    setIsResizing(true);
                }}
            />
            <Box sx={{ p: 2 }}>
                <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                    <Typography variant="h6">Insight: {insightRoute}</Typography>
                    <IconButton onClick={() => closeInsight()}>
                        <Close />
                    </IconButton>
                </Box>
                {/* Add your insight content here based on the route */}
            </Box>
        </Drawer>
    );
});

export default InsightDrawer;
